import { Navigate, useLocation } from 'react-router-dom';
import { congregantPortalLoginPath } from '../../constants';
import usePcoAuthUser from './usePcoAuthUser';

// Portal equivalent of the admin portal's requireAuth.js, gating on a
// Planning Center session instead of a Firebase one.
const RequirePcoAuth = () => {
  const location = useLocation();
  const { user, loading } = usePcoAuthUser();

  if (loading) {
    return <div></div>;
  }

  if (!user) {
    return <Navigate to={congregantPortalLoginPath} state={{ from: location }} replace />;
  }

  return <div></div>;
};

export default RequirePcoAuth;
